"use client";
import { openAppPrompt } from "@/components/layout/AppPromptSheet";
import { pushEvent } from "@/lib/analytics/gtm";
import { analyticsEvents } from "@/lib/analytics/events";
import { cn } from "@/lib/utils";

interface AppPromptTriggerProps {
  /** What the user was trying to do — feeds analytics, not visible. */
  intent: "like" | "download" | "follow";
  ariaLabel: string;
  className?: string;
  children: React.ReactNode;
}

export function AppPromptTrigger({
  intent,
  ariaLabel,
  className,
  children,
}: AppPromptTriggerProps) {
  function handleClick() {
    pushEvent(analyticsEvents.app_prompt_open, { intent });
    openAppPrompt();
  }
  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={ariaLabel}
      className={cn("text-ink hover:text-brand-600", className)}
    >
      {children}
    </button>
  );
}
